import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import BoxRendererType from '@jbrowse/core/pluggableElementTypes/renderers/BoxRendererType';
import Plugin from '@jbrowse/core/Plugin';
import { configSchema as svgFeatureRendererConfigSchema, ReactComponent as SvgFeatureRendererReactComponent } from './SvgFeatureRenderer';
var SvgFeatureRenderer = /*#__PURE__*/function (_BoxRendererType) {
  _inherits(SvgFeatureRenderer, _BoxRendererType);
  function SvgFeatureRenderer() {
    var _this;
    _classCallCheck(this, SvgFeatureRenderer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SvgFeatureRenderer).apply(this, arguments));
    _this.supportsSVG = true;
    return _this;
  }
  return SvgFeatureRenderer;
}(BoxRendererType);
var SVGPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(SVGPlugin, _Plugin);
  function SVGPlugin() {
    var _this2;
    _classCallCheck(this, SVGPlugin);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SVGPlugin).apply(this, arguments));
    _this2.name = 'SVGPlugin';
    return _this2;
  }
  _createClass(SVGPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      pluginManager.addRendererType(function () {
        return new SvgFeatureRenderer({
          name: 'SvgFeatureRenderer',
          ReactComponent: SvgFeatureRendererReactComponent,
          configSchema: svgFeatureRendererConfigSchema,
          pluginManager: pluginManager
        });
      });
    }
  }]);
  return SVGPlugin;
}(Plugin);
export { SVGPlugin as default };
export { svgFeatureRendererConfigSchema, SvgFeatureRendererReactComponent };